import 'projects/sharedComponents/src/dogAvatar/dogAvatar.scss';

import { DefaultProfilePictureIcon } from 'projects/sharedComponents/src/icons/defaultProfilePictureIcon';
import { HelixAvatar } from '@projectaussie/component-library';
import type { HelixAvatarProps } from '@projectaussie/component-library';
import React from 'react';
import clsx from 'clsx';
import { useDogAvatarBackgroundColorClass } from 'projects/sharedComponents/src/dogAvatar/dogAvatarHooks';

export type AvatarDog = {
  name: string;
  profileImageUrl: string | null;
  avatarColorIndex: number;
};

export type DogAvatarProps = HelixAvatarProps & {
  dog: AvatarDog;
  useNeutralAvatarColor?: boolean;
};

export const DogAvatar: React.FC<DogAvatarProps> = ({ dog, useNeutralAvatarColor, ...avatarProps }) => {
  const backgroundColorClass = useDogAvatarBackgroundColorClass(dog.avatarColorIndex, useNeutralAvatarColor);

  if (!!dog.profileImageUrl) {
    return <HelixAvatar {...avatarProps} src={dog.profileImageUrl} alt={`Photo of ${dog.name}`} />;
  }

  return (
    <HelixAvatar {...avatarProps} className={clsx(backgroundColorClass, avatarProps.className)}>
      <DefaultProfilePictureIcon />
    </HelixAvatar>
  );
};
